export default function MemberLinkedinIcon({ width = 46, height = 46 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23.0029"
        cy="23.3857"
        r="21.8896"
        stroke="currentColor"
        strokeOpacity="0.65"
      />
      <path
        d="M23.0029 21.0008C23.8956 20.0886 25.0579 19.4919 26.4101 19.4919C27.83 19.4919 29.1919 20.056 30.1959 21.0601C31.2 22.0641 31.7641 23.426 31.7641 24.8459V32.1469H29.8172V24.8459C29.8172 23.9423 29.4582 23.0757 28.8193 22.4368C28.1803 21.7978 27.3137 21.4388 26.4101 21.4388C25.5064 21.4388 24.6398 21.7978 24.0009 22.4368C23.3619 23.0757 23.0029 23.9423 23.0029 24.8459V32.1469H21.056V19.9786H23.0029V21.0008ZM16.1887 18.0317C15.8014 18.0317 15.43 17.8779 15.1562 17.604C14.8824 17.3302 14.7285 16.9588 14.7285 16.5715C14.7285 16.1843 14.8824 15.8128 15.1562 15.539C15.43 15.2652 15.8014 15.1113 16.1887 15.1113C16.576 15.1113 16.9474 15.2652 17.2212 15.539C17.4951 15.8128 17.6489 16.1843 17.6489 16.5715C17.6489 16.9588 17.4951 17.3302 17.2212 17.604C16.9474 17.8779 16.576 18.0317 16.1887 18.0317ZM15.2152 19.9786H17.1622V32.1469H15.2152V19.9786Z"
        fill="currentColor"
        fillOpacity="0.65"
      />
    </svg>
  );
}
